import { _ as _sfc_main } from "./VaCardTitle.vue_vue_type_script_lang-c2403df1.mjs";
import { openBlock, createElementBlock, normalizeStyle, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaCardTitle_vue_vue_type_style_index_0_scoped_f7d1a550_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "va-card-title va-card__title",
    style: normalizeStyle(_ctx.titleStyles)
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 4);
}
const VaCardTitleBase = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-f7d1a550"]]);
export {
  VaCardTitleBase as V
};

import '../../../../../VaCardTitle.css';
//# sourceMappingURL=VaCardTitle-102648f6.mjs.map
